<template>
  <div class="page_ blue_">
    <div class="content">
      <div class="title">
        {{ $t("alertPrompt[4]") || "您可以点击下列功能，进行您需要的操作" }}
      </div>
      <div class="list">
        <div
          class="list_item"
          v-for="item in list1"
          :key="item.id"
          @click="jumpTo(item)"
        >
          <img :src="item.img" alt="" />
          <p class="tit_">{{ item.title }}</p>
          <p class="sec_">{{ item.sec }}</p>
        </div>
      </div>
      <div class="list">
        <div
          class="list_item"
          v-for="item in list2"
          :key="item.id"
          @click="jumpTo(item)"
        >
          <!-- <a :href="fileUrl" v-if="item.temPlateUrl == ''"></a> -->
          <img :src="item.img" alt="" />
          <p class="tit_">{{ item.title }}</p>
          <p class="sec_">{{ item.sec }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page_ {
  background-color: #fff;
  width: 100%;
  height: 100%;
  // padding: 17px 27px 0 27px;
  border-radius: 10px;
  color: #394155;
  .content {
    width: 100%;
    .title {
      display: flex;
      justify-content: center;
      font-size: 20px;
      font-weight: 500;
      padding-top: 100px;
      margin-bottom: 70px;
      // text-align: center;
    }
    .list {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      .list_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 31%;
        height: 200px;
        margin-right: 4%;
        margin-bottom: 40px;
        background-color: #fafafa;
        border-radius: 10px;
        img {
          width: 36px;
          height: 36px;
        }
        .tit_ {
          margin-top: 17px;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .sec_ {
          font-size: 12px;
          color: #999999;
          padding: 0 5px;
          text-align: center;
        }
        &:hover {
          background-color: #f6f6f6;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>

<script>
import api from "@/utils/api";

export default {
  data() {
    return {
      addVisible: false,
      list1: [
        {
          id: 1,
          path: "/Home/PreAuthQuery",
          img: require("../assets/medilinkPC/preauth1.svg"),
          title: this.$t("preauthText[4]"),
          sec: this.$t("preauthText[5]")
        },
        {
          id: 2,
          path: "/Home/PreAuthApply",
          img: require("../assets/medilinkPC/preauth2.svg"),
          title: this.$t("preauthText[0]"),
          sec: this.$t("preauthText[1]")
        },
        {
          id: 3,
          path: "/Home/PreAuthGuide",
          img: require("../assets/medilinkPC/preauth3.svg"),
          title: this.$t("preauthText[6]"),
          sec: this.$t("preauthText[7]")
        }
      ],
      list2: [
        {
          id: 4,
          path: "/Home/PreAuthSupplement",
          img: require("../assets/medilinkPC/preauth4.svg"),
          title: this.$t("preauthText[2]"),
          sec: this.$t("preauthText[3]")
        },
        {
          id: 5,
          path: "/Home/PreAuthProve",
          img: require("../assets/medilinkPC/preauth5.svg"),
          title: this.$t("preauthText[8]"),
          sec: this.$t("preauthText[9]")
        }
      ],
      fileUrl: ""
    };
  },
  methods: {
    jumpTo(item) {
      if (item.path.indexOf("PreAuthGuide") > -1) {
        this.getServiceTemplate();
      } else if (item.path.indexOf("PreAuthProve") > -1) {
        this.getTemplate();
      } else {
        this.$router.push(item.path);
      }
    },
    getServiceTemplate() {
      api
        .getServiceTemplatePre({ templateType: "AUSERVICE" })
        .then(res => res.data)
        .then(data => {
          let fileUrl = "";
          let fileName = "";
          if (this.$i18n.locale == "zh-cn") {
            fileUrl = data.data[0].temPlateUrl;
            fileName = data.data[0].temPlateName;
          } else {
            fileUrl = data.data[1].temPlateUrl;
            fileName = data.data[1].temPlateName;
          }
          this.fileLinkToStreamDownload(fileUrl, fileName);
        });
    },
    getTemplate() {
      let type = "AUAPP";
      api
        .getTemplatePre({ templateType: type })
        .then(res => res.data)
        .then(data => {
          let fileUrl = "";
          let fileName = "";
          if (this.$i18n.locale == "zh-cn") {
            fileUrl = data.data[0].temPlateUrl;
            fileName = data.data[0].temPlateName;
          } else {
            fileUrl = data.data[1].temPlateUrl;
            fileName = data.data[1].temPlateName;
          }
          this.fileLinkToStreamDownload(fileUrl, fileName);
        });
    },
    callback(key) {
      console.log(key);
    },
    addCard() {
      this.addVisible = true;
    },
    /**
     * 文件链接转文件流下载--主要针对pdf 解决谷歌浏览器a标签下载pdf直接打开的问题
     * @param url  ：文件链接
     * @param fileName  ：文件名;
     */
    fileLinkToStreamDownload(url) {
      window.open(url);
    },
    /**
     *下载导出文件
     * @param blob  ：返回数据的blob对象或链接
     * @param tagFileName  ：下载后文件名标记
     */
    downloadExportFile(blob, tagFileName) {
      let downloadElement = document.createElement("a");
      let href = blob;
      if (typeof blob == "string") {
        downloadElement.target = "_blank";
      } else {
        href = window.URL.createObjectURL(blob); //创建下载的链接
      }
      downloadElement.href = href;
      downloadElement.download = tagFileName; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      if (typeof blob != "string") {
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }
    }
  }
};
</script>
